const DEVICE_ID_KEY = "k360_device_id";

// Identifiant unique par navigateur (partagé entre onglets via localStorage),
// envoyé au login pour le contrôle de session concurrente (1 licence = 1 navigateur).
export const getDeviceId = () => {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);

    if (!deviceId) {
        deviceId = crypto.randomUUID();
        localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }

    return deviceId;
};
